export default "__VITE_ASSET__Ow5rglDu__"